import { createContext, useContext } from 'react';
import type { DraftAction } from './model/draftReducer';
import type { ValuesByColumn } from './model/review';
import type { IssueTarget, SetupIssue } from './model/steps';
import type { MatchingConfig, MatchingSessionState } from './model/types';

/** What every step of the setup flow reads and writes. */
export interface SetupContextValue {
  session: MatchingSessionState;
  config: MatchingConfig;
  update: (action: DraftAction) => void;
  values: ValuesByColumn;
  issues: SetupIssue[];
  /** True once the run has started: everything shows, nothing edits. */
  readOnly: boolean;
  goTo: (target: IssueTarget) => void;
}

export const SetupContext = createContext<SetupContextValue | null>(null);

export function useSetup(): SetupContextValue {
  const ctx = useContext(SetupContext);
  if (!ctx)
    throw new Error('useSetup must be used inside <SetupContext.Provider>');
  return ctx;
}
